import { useMutation, useQueryClient } from "@tanstack/react-query";
import { priorityService } from "@/services/priorityService";

/** Deleting a deliverable changes PPP counts and every per-person list, so all of them refetch. */
export const useDeletePriority = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pid: string) => priorityService.deletePriority(pid),
    onSuccess: () => {
      for (const key of [["priorities"], ["ppps"], ["my-onething"], ["team-priorities"], ["accountability"]]) {
        qc.invalidateQueries({ queryKey: key });
      }
    },
  });
};
